// constants.ts

import { Box, Link, Typography } from "@mui/material";

// Chatbot Name
export const CHATBOT_WEBSITE_NAME = "Chat GPSC";

// ADMIN roles
export const PURCHASING_ADMIN_ROLE = "GPSC_Chatbot_Purchasing_Admin";
export const SQ_ADMIN_ROLE = "GPSC_Chatbot_SQ_Admin";
export const SUPPLYCHAIN_ADMIN_ROLE = "GPSC_Chatbot_SupplyChain_Admin";
export const DOMAIN_4_ADMIN_ROLE = "GPSC_Chatbot_Domain_4_Admin";
export const DOMAIN_5_ADMIN_ROLE = "GPSC_Chatbot_Domain_5_Admin";
export const DOMAIN_6_ADMIN_ROLE = "GPSC_Chatbot_Domain_6_Admin";


// NON_ADMIN roles
export const USER_ROLE = "GPSC_Chatbot_User";
export const IT_ROLE = "GPSC_Chatbot_IT";
export const NO_ACCESS_ROLE = "NoAccess";
export const NON_GPSC_USER_ROLE = "Non_GPSC_Chatbot_User";
export const ECR_AGENT_USER_ROLE = "GPSC_ECR_USER";
export const SUPPLYCHAIN_USER_ROLE = "GPSC_Chatbot_SupplyChain_User";
export const DOMAIN_4_USER_ROLE = "GPSC_Chatbot_Domain_4_User";

export const ADMIN_ROLES = [
    PURCHASING_ADMIN_ROLE,
    SQ_ADMIN_ROLE,
    SUPPLYCHAIN_ADMIN_ROLE,
    DOMAIN_4_ADMIN_ROLE,
    DOMAIN_5_ADMIN_ROLE,
    DOMAIN_6_ADMIN_ROLE
]

export const NON_ADMIN_ROLES = [
    IT_ROLE,
    USER_ROLE,
    NON_GPSC_USER_ROLE,
    ECR_AGENT_USER_ROLE,
    SUPPLYCHAIN_USER_ROLE,
    DOMAIN_4_USER_ROLE
]

export const ADMIN_AND_IT_ROLES = [...ADMIN_ROLES, IT_ROLE]

export const ALL_VALID_ROLES = [
    ...ADMIN_ROLES, ...NON_ADMIN_ROLES
]

export const DOMAIN_ID_ROLE_DICT = new Map<string, string>([
    ["1", PURCHASING_ADMIN_ROLE],
    ["2", SQ_ADMIN_ROLE],
    ["3", SUPPLYCHAIN_ADMIN_ROLE],
    ["4", DOMAIN_4_ADMIN_ROLE],
    ["5", DOMAIN_5_ADMIN_ROLE],
    ["6", DOMAIN_6_ADMIN_ROLE]
])

export const DOMAIN_USER_ROLE_ID_DICT = new Map<string, string>([
    [SUPPLYCHAIN_USER_ROLE, "3"],
    [DOMAIN_4_USER_ROLE, "4"]
])

export const RAG_AGENT = "rag"
export const ECR_AGENT = "ecr"
//export const NL2SQL_AGENT = "nl2sql"

export const MCP_AGENTS = [
    RAG_AGENT,
    ECR_AGENT
]

export const chatBotTipsAndTricks = [
    {
        text: 'Be Clear and Specific: When asking questions, be clear and specific to get the information you need. For example, instead of asking "How many days do I have to respond to my ECR in elaborate?", ask "How many days in role do I have to respond to my launch ECR in elaborate?"',
        component: (
            <Box>
                <Typography variant="h3">Be Clear and Specific: </Typography>

                <Typography variant="body1">
                    When asking questions, be clear and specific to get the information you need. For example, instead of asking "How many days do I have to
                    respond to my ECR in elaborate?", ask "How many days in role do I have to respond to my launch ECR in elaborate?"
                </Typography>
            </Box>
        )
    },
    {
        text: 'Ask Follow-ups: If the initial response is incomplete, ask for more information. For instance, if you ask "Who do I need to invite to my key stakeholder meeting?" and don\'t get the desired info, follow up with "What about specifically for Directed Buy?"',
        component: (
            <Box>
                <Typography variant="h3">Ask Follow-ups: </Typography>

                <Typography variant="body1">
                    If the initial response is incomplete, ask for more information. For instance, if you ask "Who do I need to invite to my key stakeholder
                    meeting?" and don't get the desired info, follow up with "What about specifically for Directed Buy?"
                </Typography>
            </Box>
        )
    },
    {
        text: `Rephrase Questions: If ${CHATBOT_WEBSITE_NAME} doesn't understand your question, try rephrasing it or providing more context. For example, if \"Is a BTAB required with a GS?\" doesn't provide an answer, ask \"Do I need to do a Global Sourcing before a BTAB?\"`,
        component: (
            <Box>
                <Typography variant="h3">Rephrase Questions: </Typography>
                <Typography variant="body1">
                    If {CHATBOT_WEBSITE_NAME} doesn't understand your question, try rephrasing it or providing more context. For example, if "Is a BTAB required
                    with a GS?" doesn't provide an answer, ask "Do I need to do a Global Sourcing before a BTAB?"
                </Typography>
            </Box>
        )
    },
    {
        text: `Prompt ${CHATBOT_WEBSITE_NAME}: If you want a specific type of response, prompt the ${CHATBOT_WEBSITE_NAME} accordingly. For instance, you can say, \"Can a supplier create part groups? Answer with yes or no only\" or \"What are the approvals for lump sum ED&D? Answer in one sentence.\"`,
        component: (
            <Box>
                <Typography variant="h3">Prompt {CHATBOT_WEBSITE_NAME}: </Typography>

                <Typography variant="body1">
                    If you want a specific type of response, prompt the {CHATBOT_WEBSITE_NAME} accordingly. For instance, you can say, "Can a supplier create
                    part groups? Answer with yes or no only" or "What are the approvals for lump sum ED&D? Answer in one sentence."
                </Typography>
            </Box>
        )
    },
    {
        text: `Request Information: If you're looking for specific information, ask ${CHATBOT_WEBSITE_NAME} where to find it. For example, you can ask, \"What document provides steps for a Global Sourcing?\"`,
        component: (
            <Box>
                <Typography variant="h3">Request Information:</Typography>
                <Typography variant="h5">
                    If you're looking for specific information, ask {CHATBOT_WEBSITE_NAME} where to find it. For example, you can ask, "What document provides
                    steps for a Global Sourcing?"
                </Typography>
            </Box>
        )
    }
];
export const chatBotInstructions = [
    {
        text: "Please create a test account via tums.gm.com before the UAT test. Your test account is like GMID@NAMQA.CORPQA.GEUC.corp.gm.com.",
        component: (
            <Typography variant="h5">
                Please create a test account via{" "}
                <Link href="http://tums.gm.com" target="_blank" rel="noopener noreferrer">
                    tums.gm.com
                </Link>{" "}
                before the UAT test. Your test account is in the form: <code>GMID@NAMQA.CORPQA.GEUC.corp.gm.com.</code>
            </Typography>
        )
    },
    {
        text: `You need at least to be in the GPSC Users group to chat with ${CHATBOT_WEBSITE_NAME}. Please request access as needed.`,
        component: (
            <Typography variant="h5">
                You need at least to be in the GPSC Users group to chat with <b>{CHATBOT_WEBSITE_NAME}</b>. Please request access as needed.
            </Typography>
        )
    },
    {
        text: "You need to be in the GPSC Admin group to perform the additional Admin tasks. Please request access as needed.",
        component: (
            <Typography variant="h5">You need to be in the GPSC Admin group to perform the additional Admin tasks. Please request access as needed.</Typography>
        )
    }
];
